import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import SvgCross from '@digital-hig/icon/lib/esm/icons/cross';
import SvgAlert from '@digital-hig/icon/lib/esm/display-icons/alert';
import SvgError from '@digital-hig/icon/lib/esm/display-icons/error';
import SvgInfo from '@digital-hig/icon/lib/esm/display-icons/info';
import SvgComplete from '@digital-hig/icon/lib/esm/display-icons/complete';
import { styleVariables } from '../common/constants';
import { clearMessage } from '../store/messagingSlice';
import { getInnerText } from '../common/utilities';
import { triggerManualLinkClick } from '../common/analyticsApi';

const RootElement = styled.div`
  .toast-container {
      display: flex;
      align-items: flex-start;
      padding: 20px 15px;
      margin-bottom: 12px;
      background-color: ${styleVariables.background};
      border-radius: 4px;
      width: 342px;
      box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.6), inset -1px 0px 0px rgba(0, 0, 0, 0.3), inset 1px 0px 0px rgba(0, 0, 0, 0.3), inset 0px 1px 0px rgba(0, 0, 0, 0.3);
  }
  .icon {
    svg, svg.gnosis-MuiSvgIcon-root {
      width: 24px;
      height: 24px;
    }
  }
  .close {
    margin: -10px -6px 0px 8px;
    svg {
      height: 18px;
      width: 18px;
    }
  }
  p.toast-content {
      margin: 0;
      padding: 0 10px;
      font-size: 14px !important;
      line-height: 21px;
      flex: 1;
      flex-align: middle;
  }
  .success {
      border-left: 8px solid ${styleVariables.inkSuccess}
  }
  .error {
      border-left: 8px solid ${styleVariables.fillError};
      svg {
        fill: ${styleVariables.fillError};
        color: #FFF;
      }
  }
  }
  .warning {
      border-left: 8px solid ${styleVariables.fillWarning}
  }
  .info {
      border-left: 8px solid ${styleVariables.fillEngage}
  }
  button, button:hover, button:active, button:focus, button:focus:active {
    border: 0px;
    min-width: 0px;
    padding: 2px;
    
    span {
      padding: 9px 7px;
    }
  } 

 `;
const Toast = ({
  type, children, id, closeEvent,
}) => {
  const dispatch = useDispatch();
  const removeToast = () => {
    if (closeEvent) {
      closeEvent();
    }
    dispatch(clearMessage(id));
  };

  const handleContentClick = (e) => {
    const clickableAncestor = e.target.closest('a, button');
    if (clickableAncestor) {
      triggerManualLinkClick({ linkSection: 'content', linkTitle: `toast:${type}:${getInnerText(children)}:${clickableAncestor.innerText}` });
      removeToast();
    }
  };

  return (

    <RootElement>
      <div className={`${type} toast-container`}>

        <div className="icon"><RenderIcon toasttype={type} /></div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
        <p className="toast-content" onClick={handleContentClick}>{children}</p>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <Button variant="text" className="close" onClick={removeToast}>
          <SvgCross
            id="dhig--icons--utility--cross"
            title=""
          />
        </Button>

      </div>
    </RootElement>

  );
};

function RenderIcon({ toasttype }) {
  if (toasttype === 'info') {
    return (
      <SvgInfo
        id="dhig--display-icons--info"
        title=""
        data-testid="info-icon"
      />
    );
  } if (toasttype === 'warning') {
    return (
      <SvgAlert
        id="dhig--display-icons--alert"
        title=""
        data-testid="warning-icon"
      />
    );
  } if (toasttype === 'error') {
    return (
      <SvgError
        id="dhig--display-icons--error"
        title=""
        data-testid="error-icon"
      />
    );
  }
  return (
    <SvgComplete
      id="dhig--display-icons--complete"
      title=""
      data-testid="success-icon"
    />
  );
}

RenderIcon.propTypes = {
  toasttype: PropTypes.string.isRequired,
};

Toast.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
  closeEvent: PropTypes.func,
};

Toast.defaultProps = {
  closeEvent: () => {},
};
export default Toast;
